import {
    getAllOAuthTokens,
    mapOAuthTokenByOwnerId,
    reauthOAuthToken,
    startOAuth,
    addEntityToToken,
} from './oauth.utils';

// OAuth Design Document https://pendo-io.atlassian.net/wiki/spaces/ENG/pages/602800223/Integration+OAuth+Design

const oauth = {
    namespaced: true,
    state: {
        oAuthTokens: [],
        ownerIdMap: {},
    },
    mutations: {
        setAllTokens (state, { tokens }) {
            state.oAuthTokens.push(...tokens);
        },
        setOwnerIdTokenMap (state, { map }) {
            state.ownerIdMap = map;
        },
    },
    actions: {
        async startOAuthProcess (ctx, { params }) {
            const { data } = await startOAuth(params);
            window.location = data.redirectUri;
        },
        async fetchAllOAuthTokens ({ commit }) {
            const { data } = await getAllOAuthTokens();
            const map = mapOAuthTokenByOwnerId(data);

            commit('setAllTokens', { tokens: data });
            commit('setOwnerIdTokenMap', { map });
        },
        async reauthOAuthToken (ctx, { id, redirectPath, queryParameters }) {
            const { data } = await reauthOAuthToken(id, redirectPath, queryParameters);
            window.location = data.redirectUri;
        },
        async addEntityToOAuthToken (ctx, { id, entityType, entityId }) {
            await addEntityToToken(id, entityType, entityId);
        },
    },
    getters: {
        getOAuthTokenByOwnerId: (state) => (ownerId) => state.ownerIdMap[ownerId],
        findExistingTokenForCategoryAndProvider: (state) => (category, provider) => {
            return state.oAuthTokens.find((token) => {
                return token.category === category && token.provider === provider;
            });
        },
    },
};

export default oauth;
